import { render, staticRenderFns } from "./customSale.vue?vue&type=template&id=420a8c03"
import script from "./customSale.vue?vue&type=script&lang=js"
export * from "./customSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports